"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const CheckBox_1 = require("./CheckBox");
const RenderBody = ({ isMobile = false, selectedId, tableList, styles, showCheckBox, checkedList, disableIdList, showIndex, page, showCount, totalCount, indexOrder, isInfinite, handlerSelectItem, handlerCheck, renderItem, renderMoreItem, isHome = true, }) => (react_1.default.createElement(react_1.default.Fragment, null, tableList.map((item, index) => (react_1.default.createElement(TableItem, { key: index, isMobile: isMobile, selectedId: selectedId, item: item, index: index, styles: styles, showCheckBox: showCheckBox, checkedList: checkedList, disable: disableIdList.includes(item.id), showIndex: showIndex, page: page, showCount: showCount, totalCount: totalCount, indexOrder: indexOrder, isInfinite: isInfinite, renderItem: renderItem, renderMoreItem: renderMoreItem, handlerSelectItem: handlerSelectItem, handlerCheck: handlerCheck, isHome: isHome })))));
const TableItem = ({ isMobile, selectedId, item, index, styles, showCheckBox, disable, checkedList, handlerSelectItem, handlerCheck, showIndex, page, showCount, totalCount, indexOrder, isInfinite, renderItem, renderMoreItem, }) => {
    const handleClick = (0, react_1.useCallback)((e) => {
        // Check if the click originated from the checkbox
        const target = e.target;
        // 클릭한 요소가 체크박스 또는 체크박스를 포함하는 요소인지 확인
        // @ts-ignore
        if (target.tagName === 'INPUT' && target.type === 'checkbox') {
            return; // 체크박스를 클릭한 경우, handleClick 함수 실행 중지
        }
        // 부모 요소들 중에서 체크박스를 포함하는지 검사
        if (target.closest('svg')) {
            return; // 체크박스를 포함한 요소를 클릭한 경우, handleClick 함수 실행 중지
        }
        if (handlerSelectItem) {
            handlerSelectItem(item);
        }
    }, [handlerSelectItem, item]);
    const absoluteIndex = isInfinite ? index : page * showCount + index;
    const rowNo = indexOrder === 'desc' ? totalCount - absoluteIndex : absoluteIndex + 1;
    const renderComponent = (0, react_1.useMemo)(() => (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: `${isMobile ? 'mobile_item item' : 'item'} ${selectedId === item.id ? 'selected' : ''} ${disable && 'disable'}`, style: {
                ...styles?.bodyWrapper,
                cursor: renderMoreItem || handlerSelectItem ? 'pointer' : 'default',
            }, onClick: handleClick },
            showCheckBox && (react_1.default.createElement("div", { className: "body-item body-checkbox", style: {
                    ...styles?.bodyItem,
                    minWidth: 30,
                    maxWidth: isMobile ? '30px' : 'unset',
                } }, !disable ? (react_1.default.createElement(CheckBox_1.CheckBoxElement, { id: item.id, iconSize: 22, checked: checkedList.includes(item.id), handlerCheck: handlerCheck })) : (react_1.default.createElement("div", null)))),
            showIndex && (react_1.default.createElement("div", { className: "body-item", style: { ...styles?.bodyItem, minWidth: 45, maxWidth: 60 } },
                react_1.default.createElement("p", { style: styles?.bodyText }, rowNo > 0 ? rowNo : ''))),
            renderItem(item, styles, index, isMobile)),
        /**  홈화면에서 선택한 아이템에만 하단 border 추가
             -> 요약보기 선택 시 border-radius가 적용되어 하단 밑줄이 없어지는 것 처럼 보임 **/
        selectedId === item.id && react_1.default.createElement("div", { className: "home-hr" }))), [
        item,
        checkedList,
        handlerCheck,
        showCheckBox,
        showIndex,
        page,
        showCount,
        totalCount,
        indexOrder,
        rowNo,
        renderItem,
        styles,
        isMobile,
        renderMoreItem,
    ]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        renderComponent,
        selectedId === item.id && renderMoreItem && renderMoreItem(item, styles)));
};
exports.default = RenderBody;
